import script from "./Scene_2.vue?vue&type=script&lang=js"
export * from "./Scene_2.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__